import { useState } from "react";

const defaultBrushSettings = {
  brush:     { size: 20, opacity: 100, color: "#a855f7" },
  airbrush:  { size: 40, opacity: 60,  color: "#a855f7" },
  crayon:    { size: 30, opacity: 80,  color: "#a855f7" },
  calligraphyPen: { size: 25, opacity: 90, color: "#a855f7" },
  calligraphyBrush: { size: 25, opacity: 90, color: "#a855f7" },
  oilBrush:  { size: 30, opacity: 70,  color: "#a855f7" },
  pencil:   { size: 1, opacity: 100, color: "#a855f7" },
  marker:    { size: 35, opacity: 50,  color: "#a855f7" },
  watercolor:{ size: 50, opacity: 50,  color: "#a855f7" },
};

export function useBrushSettings() {
  const [style, setStyle] = useState("brush");
  const [settings, setSettings] = useState(defaultBrushSettings);

  const current = settings[style];

  // Update current brush style
  const updateStyle = (newStyle) => {
    setStyle(newStyle);
  };

  // Update a property for the current brush
  const updateSetting = (key, value) => {
    setSettings((prev) => ({
      ...prev,
      [style]: {
        ...prev[style],
        [key]: value,
      },
    }));
  };

  return { settings, style, current, updateStyle, updateSetting };
}
